module.exports = __webpack_public_path__ + "media/background720.f84cd461.mp4";